import { SandhillsSlickSlider, Panel } from '@Components/Shared/SandhillsSlickSlider';
import translator from '@Components/Utilities/Translator';
import { useWindowSize } from '@Components/Utilities/WindowSize';
import atoms from '@Components/Utilities/SandhillsAtoms';
import { useRecoilValue } from 'recoil';

const FTIWantToBuys = (props) => {

    const windowSize = useWindowSize();
    const routes = useRecoilValue(atoms.routes);

    return (
        <div class="fti-wtbs">
            <div class="container">
                <div class="featured-section-title">
                    <span className='lefter'><img src='/Content/images/FTIPlug/logo-fti-dark.png' alt='Fast Track Iron Logo' /><h3><a className='cloud-link' href={routes.CloudWTBs} target='_blank'>{translator.translate('sandhills.wanttobuys')} <i className='fas fa-external-link-alt' /><span className='visually-hidden'>Opens in a new tab</span></a></h3></span> {!windowSize.isMobile && <a className='wtb-button ts-button' href='/want-to-buy?dwswtb=1'>{translator.translate('sandhills.tradepubwebsite.postawanttobuy')}</a>}
                </div>
            </div>
            <div class="fti-wtbs-container">
                <SandhillsSlickSlider
                    {...props}
                    settings={{
                        slidesToShow: props.ftis.length > 4 ? 4 : props.ftis.length,
                        slidesToScroll: 4,
                        arrows: true,
                        autoplay: false,
                        infinite: true,
                        responsive: [
                            {
                                breakpoint: 1400,
                                settings: {
                                    slidesToShow: 3,
                                    slidesToScroll: 3,
                                }
                            },
                            {
                                breakpoint: 1130,
                                settings: {
                                    slidesToShow: 2,
                                    slidesToScroll: 2,
                                }
                            },
                            {
                                breakpoint: 860,
                                settings: {
                                    slidesToShow: 1,
                                    slidesToScroll: 1,
                                }
                            }
                        ]
                    }}
                >
                    {props.ftis.map((wtb) =>
                        <Panel
                            key={`slider-${wtb.Title}-${wtb.CreatedOn}`}
                            PanelType={'FTIWTB'}
                            PanelClass={'fti-wtb'}
                            OuterDivClass={'fti-wtb-record'}
                            InnerDivClass={"featured-fti-wtb-div"}
                            {...wtb}
                        />)}
                </SandhillsSlickSlider>
            </div>
            {windowSize.isMobile && <a className='wtb-button ts-button' href='/want-to-buy?dwswtb=1'><div>{translator.translate('sandhills.tradepubwebsite.postawanttobuy')}</div></a>}
        </div>
    );
}

export default FTIWantToBuys;